import { getSessionKey } from 'storage/sessionKey'

export const getAuthorizationSessionHeader = (): string | undefined => {
    const sessionKey = getSessionKey()

    if (!sessionKey) {
        return
    }

    return `Session ${sessionKey}`
}
